import React from "react";
import { Save, FileDown, Share2, Info } from "lucide-react";
import { Button } from "components/ui/button";

const PeerPageHeader = ({ onSave, onExport }) => {
  return (
    <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 w-full">
      <div className="flex flex-col">
        <div className="flex items-center gap-3 mb-1">
          <h1 className="text-2xl font-semibold text-gray-900 m-0 tracking-tight">Peer Benchmarking</h1>
        </div>
        <p className="text-sm text-gray-500 m-0 max-w-3xl leading-relaxed">
          Identify institutional peers, compare performance metrics, and uncover strategic insights.
        </p>
      </div>

    </div>
  );
};

export default PeerPageHeader;
